import { Component, Pipe, PipeTransform } from '@angular/core';

import 'moment/locale/pt-br';
import * as moment_ from 'moment';
const moment = moment_;
moment.locale('pt-br');

@Pipe({name: 'groupByDate'})
export class GroupByPipe implements PipeTransform {
transform(collection: Array<any>, property: string = 'number'): Array<any> {

    if(!collection) { return null; }

    const gc = collection.reduce((previous, current)=> {

        const date = moment.unix(current[property]).format('DD-MM-YYYY');

        if(!previous[date]) { previous[date] = []; }

        previous[date].push(current);

        return previous;

    }, {});

    return Object.keys(gc).map(date => ({ header: { open: true, date: date, number: gc[date][0].number }, TicketsItems: gc[date] }));
    }
}
